import React from "react";
import ProspectUsersHeader from "./ProspectUsersHeader";
import ProspectUsersContent from "./ProspectUsersContent";
import RightModal from "../../Modals/RightModal/RightModal";

const ProspectUsers = () => {
  return (
    <div className="w100 d-flex flex-column gap-4 h-100">
      <ProspectUsersHeader />
      <ProspectUsersContent />
      <RightModal width={60} />
    </div>
  );
};

export default ProspectUsers;
